import React from 'react';
import { LanguageConsumer } from '../../../config/LanguageContext';
import Wordings from '../../../config/stringTable';

export default function PinwheelError() {
  return (
    <LanguageConsumer>
      {({ language }) => (
        <>
          <h2>{ Wordings[language]['Error Occurred'] }</h2>
          <p>{ Wordings[language].ErrorLoadingPayroll }</p>
        </>
      )}
    </LanguageConsumer>
  );
}
